import * as actions from './finalize-register.actions'
import { identity } from 'fp-ts/lib/function'
import { Reducer } from 'src/framework'

export interface FinalizeRegisterState {}

export const initialFinalizeRegisterState = {}

export const sameState: (s: FinalizeRegisterState) => FinalizeRegisterState = identity

export const finalizeRegisterReducer: Reducer<
  actions.FinalizeRegisterActions,
  FinalizeRegisterState
> = actions.finalizeRegisterActions.match({
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/users-components/finalize-register/finalize-register.reducer.ts